import React from "react";

/**
 * SWIA Logo — sharp, typographic wordmark (black on white by default).
 * Inverted variant flips to white on black for dark sections.
 */
export default function Logo({ className = "", inverted = false, size = "md" }) {
  const color = inverted ? "#ffffff" : "#0a0a0a";
  const sizes = {
    sm: { height: 20, letter: 20, tracking: 4 },
    md: { height: 26, letter: 26, tracking: 5 },
    lg: { height: 42, letter: 42, tracking: 7 },
    xl: { height: 96, letter: 96, tracking: 12 },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div
      className={`inline-flex items-center ${className}`}
      data-testid="swia-logo"
      aria-label="SWIA — Sterling West Insurance Agency"
    >
      <svg
        width={s.letter * 3.6}
        height={s.height}
        viewBox="0 0 220 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
      >
        <rect x="0" y="28" width="8" height="8" fill={color} />
        <rect x="14" y="28" width="8" height="8" fill={color} />
        <text
          x="32"
          y="46"
          fontFamily="Cabinet Grotesk, Satoshi, sans-serif"
          fontWeight="900"
          fontSize="44"
          letterSpacing={s.tracking}
          fill={color}
        >
          SWIA
        </text>
      </svg>
    </div>
  );
}
